import { track, useTracking } from 'lib/babylistHealthAnalytics'
import { formFieldClickedEvent } from '../../events/formFieldClickedEvent'
import { useLayout } from '../Layout'
import InsurancePickerForm from '../../forms/InsurancePickerForm/InsurancePickerForm'
import { pumpCatalogSelectedEvent } from '../../events/pumpCatalogSelectedEvent'

export interface InsuranceMetadata {
  insuranceState: string
  insuranceProvider: APIResponse.Insurance
}

export interface InsurancePickerProps {
  onViewOptions?: (insuranceMetadata: InsuranceMetadata) => void
}

export interface FormValues {
  email?: string
}

export default function InsurancePickerWidget({
  onViewOptions,
}: InsurancePickerProps) {
  const tracker = useTracking()
  const layout = useLayout()
  const experimentGroup = layout?.experiment
    ?.dmeUserReEngagementEmailCapture as string

  const fireFormFieldClickedEvent = (formFieldName: string) => {
    formFieldClickedEvent(tracker)({
      formName: track.FormName.INSURANCE_FORM,
      formFieldName,
    })
  }

  return (
    <InsurancePickerForm
      onInsuranceCarrierFieldFocus={() =>
        fireFormFieldClickedEvent(track.FormFieldName.INSURANCE_PROVIDER)
      }
      onInsuranceStateFieldFocus={() =>
        fireFormFieldClickedEvent(track.FormFieldName.INSURANCE_STATE)
      }
      onSubmitSuccess={({
        emailProvided,
        insuranceState,
        insuranceCarrier,
      }) => {
        pumpCatalogSelectedEvent(tracker)({
          insuranceProvider: insuranceCarrier.company,
          insuranceProviderId: insuranceCarrier.id,
          insuredState: insuranceState,
          emailProvided,
          emailExperimentGroup: experimentGroup || 'none',
        })
        onViewOptions?.({
          insuranceState,
          insuranceProvider: insuranceCarrier,
        })
      }}
    />
  )
}
